import storageAndCookie from '../../storage-and-cookies';
import { vmTypes } from '../../../global-prop-types';

export const setCookie = (name, days) => () => storageAndCookie.set(
  name,
  `${window.location.pathname}${window.location.search}`,
  days
);

export const setCookie2 = (name, value, days) => {
  console.log('set cookie 2')
  storageAndCookie.set(
    name,
    value,
    days,
    true
  );
}

export const getCookie = (name) => storageAndCookie.get(name, true);

getCookie.vmFunctionMetaData = {
  returnVmType: vmTypes.string,
  argsInfo: [
    { uiTitle: 'Cookie name', vmType: vmTypes.string }
  ]
};
